import { useTranslation } from "react-i18next";

import Schemas from "schemas";
import { Feedback } from "types";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form } from "components/ui-kit/styled-templates";

import ReviewsApi from "api/reviews-api";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals } from "types/enums";

const CreateFeedbackModal = () => {
    const { t } = useTranslation();

    const { onSubmit, clearForm } = useFormControl({ name: EForms.createFeedback, schema: Schemas[EForms.createFeedback] });
    const { close, state: modalState = {} } = useModal(EModals.CreateFeedback, {});
    const { dormitoryId, eventId } = modalState;

    const handlers = {
        submit: async (feedback: Omit<Feedback, "id" | "published">) => {
            if (dormitoryId) {
                await ReviewsApi.createReview({ ...feedback, dormitoryId });
                close();
            }
            if (eventId) {
                await ReviewsApi.createReview({ ...feedback, eventId });
                close();
            }
        },
    };
    return (
        <PopUpWrapper name={EModals.CreateFeedback} onClose={clearForm}>
            <Form
                name={EForms.createFeedback}
                onSubmit={onSubmit(handlers.submit)}
                extra={`h3 { margin-top: 0; }; display: flex; flex-direction: column; align-items: center;`}
            >
                <h2>{t("modals.CreateFeedback.title")}</h2>
                <Control.Stars name="rating" />
                <Control.Input
                    name="topic"
                    label={t("modals.CreateFeedback.form.topic.label")}
                    placeholder={t("modals.CreateFeedback.form.topic.placeholder")}
                    isRequired
                />
                <Control.Textarea
                    name="text"
                    label={t("modals.CreateFeedback.form.text.label")}
                    placeholder={t("modals.CreateFeedback.form.text.placeholder")}
                    isRequired
                />
                <Control.File
                    name="photos"
                    label={t("modals.CreateFeedback.form.photos.label")}
                    multiple
                    dropzoneProps={{ label: t("modals.CreateFeedback.form.photos.placeholder") }}
                />
                <Button type="submit" background="green">
                    {t("modals.CreateFeedback.form.confirmButton")}
                </Button>
            </Form>
        </PopUpWrapper>
    );
};

export default CreateFeedbackModal;
